import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import React from "react";
import { useField } from "formik";
import { MyCheckBoxInputProps } from "../../../../../../templates/Interfaces";
import OptionContainer from "./OptionContainer";
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';


export const TextAlignSelector = (props: MyCheckBoxInputProps) => {
    const { label, name } = props;
    const [field, , { setValue }] = useField(name);

    const handleAlignmentChange = (event: React.MouseEvent<HTMLElement>, newValue: string) => {
        setValue(newValue);
    };

    return (
        <OptionContainer>
            <Typography>{label}</Typography>
            <ToggleButtonGroup value={field.value || ''} exclusive onChange={handleAlignmentChange}>
                <ToggleButton value="left"><FormatAlignLeftIcon /></ToggleButton>
                <ToggleButton value="center"><FormatAlignCenterIcon /></ToggleButton>
                <ToggleButton value="right"><FormatAlignRightIcon /></ToggleButton>
            </ToggleButtonGroup>
        </OptionContainer>
    );
};

export default TextAlignSelector;